import EstadoDocumento from "common/components/EstadoDocumento/EstadoDocumento"
import { ESTADO_REVISION_PROPERTIES } from "common/utils/constants"
import { useTranslation } from "react-i18next"

const DetailStepItem = ({
  isEtapaRejected,
  validateTotalSigns,
  getFirmantesArray,
  etapa,
  userType,
  isCurrentStep,
  disabled,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <li
      className={`tw-mb-2 tw-text-text-50 tw-flex tw-justify-between tw-items-center ${
        isCurrentStep ? "tw-font-medium !tw-text-shadow-default" : ""
      }`}
    >
      <div className='tw-flex tw-items-baseline tw-gap-1'>
        <span className="tw-w-3 tw-h-3 tw-rounded-full tw-border-2 tw-border-primary tw-relative before:tw-content-[''] before:tw-absolute before:tw-top-3 before:tw-w-0.5 before:tw-border-r-2 before:tw-border-dotted before:tw-border-[#c1b8b8] last:before:tw-border-r-0" />

        <p
          className={`tw-text-sm ${
            isEtapaRejected ? "tw-text-neutral-75" : ""
          }`}
        >
          {userType}
          {validateTotalSigns &&
            !isEtapaRejected &&
            validateTotalSigns(getFirmantesArray(), etapa)}
        </p>
      </div>
      {!isEtapaRejected ? (
        <EstadoDocumento
          backgroundColor='white'
          color={ESTADO_REVISION_PROPERTIES(t)[1].color}
          text={ESTADO_REVISION_PROPERTIES(t)[1].text}
          className='tw-flex !tw-justify-end !tw-p-0 tw-text-sm'
          disabled={isEtapaRejected || disabled}
        />
      ) : null}
    </li>
  )
}

export default DetailStepItem
